module.exports = __webpack_public_path__ + "img/app-icon.3eeb0ee1.svg";